module.exports = __webpack_public_path__ + "static/media/calendar-alt.78beb9f5.svg";